import React from "react";
import {
  Card,
  Button,
  Modal,
  Row,
  Col,
  Input,
  Radio,
  Divider,
  List,
} from "antd";
import Axios from "../../../config/axios";
import withErrorHandler from "hoc/withErrorHandler";
import Loading from "components/Loading";
import openNotificationWithIcon from "helpers/notification";

const FILE_TYPE = ["image/png", "image/jpeg"];
class Letterhead extends React.Component {
  state = {
    letterhead: {
      unit_id: "",
      file: {},
      no_hp1: "",
      no_hp2: "",
      sync_eoffice: false,
    },
    modal: false,
    prodiModal: false,
    majors: [],
    previewImage: "",
  };

  componentDidMount() {
    this.fetchLetterHead();
    if (["admin", "operator"].includes(this.props.user.info.type)) {
      this.fetchMajor();
    }
  }

  toggleModal = (previewImage = "") => {
    this.setState({ modal: !this.state.modal, previewImage });
  };

  toggleProdiModal = () => {
    this.setState({ prodiModal: !this.state.prodiModal });
  };

  getParams = () => {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    return Object.fromEntries(urlSearchParams.entries());
  };

  fetchMajor = async () => {
    const response = await Axios.get(
      `/major-by-faculty?unit_id=${this.props.user.info.unit_id}`
    );

    const majors = response.data?.map(async (major) => {
      const headResponse = await Axios.get(`/letterhead?unit_id=${major.id}`);
      const foundHead = headResponse.data.payload?.find(
        (head) => head.unit_id === major.id
      );
      return { ...major, letterhead: foundHead };
    });

    const result = await Promise.all(majors);
    this.setState({ majors: result });
  };

  fetchLetterHead = () => {
    Axios.get(
      "/letterhead?unit_id=" +
        (this.props.user.info.type === "admin"
          ? this.getParams().unit_id
          : this.props.user.info.unit_id)
    ).then((response) => {
      if (response.data.payload[0])
        this.setState({ letterhead: response.data.payload[0] });
    });
  };

  handleChangeFile = (e) => {
    const { letterhead } = this.state;
    const file = e.target.files[0];
    if (!FILE_TYPE.includes(file.type)) {
      openNotificationWithIcon(
        "error",
        "Upload File",
        "Format file tidak didukung"
      );
      return;
    }
    letterhead.file = file;
    this.setState({ letterhead });
  };

  handleSave = (letterhead) => {
    if (!letterhead) {
      openNotificationWithIcon(
        "error",
        "Upload Kop Surat",
        "File tidak ditemukan"
      );
      return;
    }
    var formData = new FormData();
    formData.append(
      "unit_id",
      this.props.user.info.type === "admin"
        ? this.getParams().unit_id
        : letterhead.unit_id !== ""
        ? letterhead.unit_id
        : this.props.user.info.unit_id
    );
    formData.append("file", letterhead.file);
    formData.append("no_hp1", letterhead.no_hp1);
    formData.append("no_hp2", letterhead.no_hp2);
    if (typeof letterhead.sync_eoffice !== "undefined") {
      formData.append("sync_eoffice", letterhead.sync_eoffice);
    }
    Axios.request({
      method: letterhead._id ? "PUT" : "POST",
      data: formData,
      url: "/letterhead/save" + (letterhead._id ? "/" + letterhead._id : ""),
    }).then(() => {
      // window.location.reload()
      this.fetchLetterHead();
      openNotificationWithIcon(
        "success",
        "Pengaturan",
        "Pengaturan berhasil diupdate."
      );
    });
  };

  handleSaveCurrentUser = () => {
    const { letterhead } = this.state;
    this.handleSave(letterhead);
  };

  handleChangeForm = (e) => {
    let val = e.target.value;
    if (e.target.name === "sync_eoffice") val = val === "1" ? true : false;
    let { letterhead } = this.state;
    letterhead[e.target.name] = val;
    this.setState({ letterhead });
  };

  handleChangeFileMajor = (index, val) => {
    const file = val.target.files[0];

    const { majors } = this.state;
    if (!FILE_TYPE.includes(file.type)) {
      openNotificationWithIcon(
        "error",
        "Upload File",
        "Format file tidak didukung"
      );
      return;
    }
    majors[index].letterhead = majors[index].letterhead
      ? { ...majors[index].letterhead, file }
      : {
          file,
          no_hp1: "",
          no_hp2: "",
          unit_id: majors[index].id,
        };
    this.setState({ majors });
  };

  render() {
    return (
      <Row>
        <Col sm={20} md={8} style={{ margin: 15 }}>
          <Card
            title="Upload Kop Surat"
            extra={
              <div
                onClick={() => this.toggleModal(this.state.letterhead.file)}
                style={{ cursor: "pointer" }}
              >
                Lihat
              </div>
            }
          >
            <Row align="top" justify="space-between" gutter={[16, 16]}>
              <Col>
                <input type="file" onChange={this.handleChangeFile} />
              </Col>
              <Col>
                <Button type="primary" onClick={this.handleSaveCurrentUser}>
                  Simpan
                </Button>
              </Col>
              {["admin", "operator"].includes(this.props.user.info.type) ? (
                <>
                  <Col span={24}>
                    <Divider type="horizontal" />
                  </Col>
                  <Col span={24}>
                    <Button
                      style={{ width: "100%" }}
                      onClick={this.toggleProdiModal}
                    >
                      Lihat Kop Surat Prodi
                    </Button>
                  </Col>
                </>
              ) : null}
            </Row>
          </Card>
        </Col>
        {["operator", "admin"].includes(this.props.user.info.type) ? (
          <>
            <Col sm={20} md={8} style={{ margin: 15 }}>
              <Card title="Kontak">
                <div>
                  <label>Kontak 1</label>
                  <Input
                    onChange={this.handleChangeForm}
                    name="no_hp1"
                    value={this.state.letterhead.no_hp1}
                  />
                </div>
                <div>
                  <label>Kontak 2</label>
                  <Input
                    onChange={this.handleChangeForm}
                    name="no_hp2"
                    value={this.state.letterhead.no_hp2}
                  />
                </div>
                <Button
                  onClick={this.handleSaveCurrentUser}
                  type="primary"
                  style={{ marginTop: 20 }}
                >
                  Simpan
                </Button>
              </Card>
            </Col>
            <Col sm={20} md={6} style={{ margin: 15 }}>
              <Card title="Sync dengan E-Office">
                <div>
                  <Radio.Group
                    onChange={this.handleChangeForm}
                    name="sync_eoffice"
                    value={this.state.letterhead.sync_eoffice ? "1" : "0"}
                  >
                    <Radio value="1">Ya</Radio>
                    <Radio value="0">Tidak</Radio>
                  </Radio.Group>
                </div>
                <Button
                  onClick={this.handleSaveCurrentUser}
                  type="primary"
                  style={{ marginTop: 20 }}
                >
                  Simpan
                </Button>
              </Card>
            </Col>
          </>
        ) : null}

        <Modal
          footer={null}
          visible={this.state.prodiModal}
          onCancel={this.toggleProdiModal}
          title="Kop Surat Prodi"
        >
          <List
            dataSource={this.state.majors}
            renderItem={(item, index) => (
              <List.Item>
                <Row>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Col>
                        <Col span={24}>Nama: {item.name}</Col>
                        <Col span={24}>Level: {item.level}</Col>
                      </Col>
                      <Col>
                        <Button
                          onClick={() =>
                            this.toggleModal(item.letterhead?.file)
                          }
                        >
                          Lihat Kop Surat
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Col>
                        <input
                          type="file"
                          value={item.file}
                          onChange={(val) =>
                            this.handleChangeFileMajor(index, val)
                          }
                        />
                      </Col>
                      <Col>
                        <Button
                          type="primary"
                          onClick={() => this.handleSave(item.letterhead)}
                        >
                          SIMPAN
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </List.Item>
            )}
          />
        </Modal>
        <Modal
          footer={null}
          visible={this.state.modal}
          onCancel={this.toggleModal}
        >
          <img src={this.state.previewImage} alt="" style={{ width: "100%" }} />
        </Modal>
        <Loading loading={this.props.loading} />
      </Row>
    );
  }
}

export default withErrorHandler(Letterhead, Axios);
